module.exports = __webpack_public_path__ + "img/ltk_litecake.gm.7445c08.png";